import { render, staticRenderFns } from "./SelectConfigComponent.vue?vue&type=template&id=04704b92&scoped=true&"
import script from "./SelectConfigComponent.vue?vue&type=script&lang=js&"
export * from "./SelectConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04704b92",
  null
  
)

export default component.exports